import React, { useEffect, useState } from 'react';
import PT from 'prop-types';

import ToggleButton from 'Components/ToggleButton/ToggleButton';

const Switches = ({ switches, fieldProps: { onChange, value } }) => {
  const [state, setState] = useState(null);

  useEffect(() => {
    const state = switches.reduce((obj, { name }) => {
      if (name) obj[name] = value && name in value ? value[name] : false;
      return obj;
    }, {});

    setState(state);
  }, []);

  useEffect(() => {
    setState((prevState) => ({ ...prevState, ...value }));
  }, [value]);

  const getState = (key) => state ? state[key] : false;

  const handleChange = (name) => {
    if (onChange) onChange({ ...state, [name]: !state[name] });
  };

  return (
    <div className="switches-field-wrapper">
      {switches.map((item) => (
        <div key={item.name} className="switches-field">
          <div className="switches-field__img">
            {item.getIcon(getState(item.name))}
          </div>
          <div className="switches-field__text">
            <p className="switches-field__title">{item.label}</p>
            <p className="switches-field__description">{item.subLabel}</p>
          </div>
          <div className="switches-field__checkbox">
            <ToggleButton
              onToggleChange={handleChange.bind(null, item.name)}
              toggleStatus={getState(item.name)}
              inversion
              extractToggle
              id={`switch-${item.name}`}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

Switches.propTypes = {
  switches: PT.arrayOf(PT.object),
  fieldProps: PT.object,
};

export default Switches;
